import { catalogueRequestsChanged } from './cataloguePhase2Model';
export function bindCatalogueRequestHints(socket) {
  if (!socket) return () => {};
  socket.on('catalogue.requests.changed', catalogueRequestsChanged);
  socket.on('connect', catalogueRequestsChanged);
  return () => { socket.off('catalogue.requests.changed', catalogueRequestsChanged); socket.off('connect', catalogueRequestsChanged); };
}
